import { useState, useRef, useEffect } from 'react';
import salespipeline from '../assets/solutions/salespipeline.svg';
import leadgen from '../assets/solutions/leadgen.svg';
import coldemail from '../assets/solutions/coldemail.svg';
import contentsystems from '../assets/solutions/contentsystems.svg';
import email from '../assets/solutions/email.svg';
import agenticworkflows from '../assets/solutions/agenticworkflows.svg';
import documents from '../assets/solutions/documents.svg';
import rechnung from '../assets/solutions/rechnung.svg';
import companybrain from '../assets/solutions/companybrain.svg';
import analytics from '../assets/solutions/analytics.svg';
import predictiveinsights from '../assets/solutions/predictiveinsights.svg';
import automatedseo from '../assets/solutions/automatedseo.svg';
import kundenservice from '../assets/solutions/kundenservice.svg';
import support from '../assets/solutions/support.svg';
import circlecheck from '../assets/solutions/circle-check.svg';
import chart from '../assets/solutionsdash/chart.svg';
import folder from '../assets/solutionsdash/folder.svg';
import message from '../assets/solutionsdash/message.svg';
import monitor from '../assets/solutionsdash/monitor.svg';
import BLCKS_LOGO_NEW from '../assets/icons/BLCKS_LOGO_NEW.svg';
import ProductCardBg from '../assets/solutions/ProductCardBg.avif';
import fullline from '../assets/solutions/FullLineNew.svg';
import feedback from '../assets/solutions/feedback.svg';
import intake from '../assets/solutions/intake.svg';

const Solutions_Dash_Mobile = () => {
  // State to track active sidebar item
  const [activeSidebar, setActiveSidebar] = useState('Sales Block');
  const carouselRef = useRef(null);

  // Reset carousel scroll position when active sidebar changes
  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }, [activeSidebar]);

  // All dashboard items by category
  const dashboardItemsByCategory = {
    'Sales Block': [
      { 
        id: 1,
        icon: "salespipeline",
        title: "KI Sales Pipeline",
        description: "Behalte den Überblick über deinen Vertriebsprozess. Unsere KI organisiert Leads, automatisiert Outreach und Follow-ups und priorisiert Chancen damit deine Pipeline gefüllt und effizient gemanagt ist.",
        features: [
          "Lead Generierung & Qualifikaton",
          "Multi-Channel Outreach",
          "Follow-Ups & Terminbuchungen",
          "KI Kampagnenoptimierung"
        ]
      },
      { 
        id: 2,
        icon: "leadgen",
        title: "KI Leadgenerierung",
        description: "Finde automatisch neue, passende Kunden ohne manuelle Recherche. Unsere KI identifiziert relevante B2B-Leads basierend auf deinem Idealprofil und liefert dir qualifizierte Kontakte direkt in deine Pipeline.",
        features: [
          "Automatische Leadrecherche",
          "Lead Enrichment",
          "Lead Scoring & Priorisierung",
          "Automatisierte Berichte"
        ]
      },
      { 
        id: 3,
        icon: "coldemail",
        title: "KI Cold Email Systems",
        description: "Starte skalierbare, personalisierte E-Mail-Kampagnen vollautomatisch. Die KI schreibt, testet und versendet Cold Emails, die konvertieren abgestimmt auf Branche, Position und Bedarf deiner Zielgruppe.",
        features: [
          "Verfassen personalisierter E-Mails",
          "A/B-Testing für Betreffzeilen und Texte",
          "Automatische Follow-ups",
          "Öffnungs- und Antwortratenoptimierung"
        ]
      },
      { 
        id: 4,
        icon: "contentsystems",
        title: "KI Content Systems",
        description: "Erstelle hochwertigen Vertriebs- und Marketing-Content in Minuten. Ob LinkedIn-Posts, Blogartikel oder Pitch-Material. Die KI liefert passenden Content für jede Phase deiner Customer Journey.",
        features: [
          "Automatische Content Erstellung",
          "Automatische Blogerstellung",
          "Dynamische Anpassung an Zielgruppen",
          "Content Performance Tracking"
        ]
      }
    ],
    'Office Block': [
      { 
        id: 5,
        icon: "email",
        title: "E-Mail Automatisierung",
        description: "Schluss mit Postfach-Chaos und manuellem Sortieren. Unsere KI kategorisiert, priorisiert und beantwortet E-Mails automatisch damit du dich auf das Wesentliche konzentrieren kannst.",
        features: [
          "Automatisches Kategorisieren und Priorisieren",
          "Intelligente E-Mail Beantwortung",
          "Intent- und Sentiment Analyse",
          "Anbindung an deine Tools"
        ]
      },
      { 
        id: 6,
        icon: "agenticworkflows",
        title: "Agentic Workflows",
        description: "Arbeitsprozesse, die sich selbst steuern. Von Auftragseingang bis Fullfillment übernimmt die KI Entscheidungen, verteilt Aufgaben intelligent und sorgt für reibungslose Abläufe in Echtzeit.",
        features: [
          "Automatisierte Auftragseingänge & Fullfillment",
          "Intelligente Zuweisung & Entscheidungen",
          "Status-Updates in Echtzeit",
          "Self-Learning-Workflows"
        ]
      },
      { 
        id: 7,
        icon: "documents",
        title: "Dokumentenmanagement",
        description: "Dokumente finden, erstellen und verwalten – ohne Aufwand. Die KI organisiert Dateien automatisch, sorgt für schnelle Suchergebnisse und hält alles revisionssicher bereit.",
        features: [
          "Automatische Klassifizierung & Ablage",
          "Volltext-Suche über alle Dateien",
          "Versionskontrolle & Freigabeprozesse",
          "Sicherheit & Compliance integriert"
        ]
      },
      { 
        id: 8,
        icon: "rechnung",
        title: "Rechnungsmanagement",
        description: "Rechnungen verarbeiten, prüfen und buchen – vollautomatisch. Die KI erkennt Belege, gleicht sie mit Bestellungen ab und übernimmt Erinnerungen sowie Mahnwesen zuverlässig.",
        features: [
          "Automatisches Erkennen von Rechnungen & Belegen",
          "Matching mit Bestellungen & Verträgen",
          "Zahlungserinnerungen und Mahnwesen",
          "Export in Buchhaltungssoftware"
        ]
      }
    ],
    'Insight Block': [
      { 
        id: 9,
        icon: "companybrain",
        title: "KI Company Brain",
        description: "Das zentrale Gedächtnis deines Unternehmens. Wissen, Dokumente und Insights werden vereint, sodass deine Mitarbeiter in Sekunden Antworten und Zusammenfassungen finden.",
        features: [
          "Einheitliche Wissensdatenbank",
          "Q&A-KI Assistent für schnelle Antworten",
          "Kontextuelle Suche & Dokumentenzusammenfassungen",
          "Automatische Reporterstellung"
        ]
      },
      { 
        id: 10,
        icon: "analytics",
        title: "KI Business Analytics",
        description: "Echtzeit-Analysen, die jeder versteht. Unsere KI aktualisiert KPIs automatisch, erkennt Trends und liefert handlungsorientierte Empfehlungen für bessere Entscheidungen.",
        features: [
          "KPI-Dashboards automatisch aktualisiert",
          "Drill-down Analysen nach Abteilungen",
          "Prognosen auf Basis historischer Daten",
          "Alerts bei Abweichungen und Trends"
        ]
      },
      { 
        id: 11,
        icon: "predictiveinsights",
        title: "KI Predictive Insights",
        description: "Entdecke Muster und Anomalien in deinen Daten sofort. Die KI analysiert Zusammenhänge, liefert Insights automatisch und zeigt dir direkt umsetzbare Empfehlungen.",
        features: [
          "Anomalienerkennung in Echtzeit",
          "Zusammenhänge und Korrelationen",
          "Automatisierte Insights",
          "Handlungsempfehlungen"
        ]
      },
      { 
        id: 12,
        icon: "automatedseo",
        title: "KI Automated SEO",
        description: "Mehr Sichtbarkeit ohne manuellen Aufwand. Die KI optimiert Keywords, Inhalte und technische Faktoren kontinuierlich, passt sich an neue Suchtrends an und verbessert so dein Ranking automatisch.",
        features: [
          "Automatisierte Wettbewerbsanalyse",
          "Markttrends in Echtzeit",
          "Kundenfeedback-Auswertung",
          "Predictive Analytics"
        ]
      }
    ],
    'Service Block': [
      { 
        id: 13,
        icon: "kundenservice",
        title: "KI Kundenservice Agent",
        description: "Dein virtueller Support rund um die Uhr. Die KI beantwortet Anfragen sofort, übernimmt wiederkehrende Aufgaben und sorgt für schnellen, freundlichen Service über alle Kanäle hinweg.",
        features: [
          "24/7 Verfügbarkeit",
          "Mehrsprachiger Support",
          "Kontextbewusste Antworten",
          "Nahtlose Übergabe an menschliche Agenten"
        ]
      },
      { 
        id: 14,
        icon: "support",
        title: "KI Supportautomatisierung",
        description: "Reduziere Tickets und steigere Lösungsgeschwindigkeit. Die KI sortiert, priorisiert und beantwortet Anfragen automatisch – für effizienteren Support und zufriedenere Kunden.",
        features: [
          "Individuelle Einführungsprozesse",
          "Interaktive Tutorials",
          "Fortschrittsverfolgung",
          "Automatisierte Erinnerungen"
        ]
      },
      { 
        id: 15,
        icon: "feedback",
        title: "KI Feedback & Umfragen",
        description: "Kundenzufriedenheit messen ohne manuelle Nacharbeit. Die KI versendet Umfragen automatisch, analysiert Antworten in Echtzeit und liefert dir direkt umsetzbare Handlungsempfehlungen.",
        features: [
          "Automatische Kategorisierung",
          "Intelligente Suche",
          "Wissenslücken erkennen",
          "Team-Kollaboration"
        ]
      },
      { 
        id: 16,
        icon: "intake",
        title: "KI HR Intake Systems",
        description: "Recruiting und Onboarding, die sich selbst organisieren. Die KI analysiert Bewerbungen, matched Profile mit Stellenanforderungen und begleitet neue Mitarbeiter automatisch durch den Startprozess.",
        features: [
          "Sentiment Analyse",
          "Themenerkennung",
          "Handlungsempfehlungen",
          "Automatisierte Berichte"
        ]
      }
    ]
  };

  // Map icon names to their imported components
  const iconMap = {
    salespipeline: salespipeline,
    leadgen: leadgen,
    coldemail: coldemail,
    contentsystems: contentsystems,
    email: email,
    agenticworkflows: agenticworkflows,
    documents: documents,
    rechnung: rechnung,
    companybrain: companybrain,
    analytics: analytics,
    predictiveinsights: predictiveinsights,
    automatedseo: automatedseo,
    kundenservice: kundenservice,
    support: support,
    feedback: feedback,
    intake: intake
  };

  // Get current dashboard items based on active sidebar
  const dashboardItems = dashboardItemsByCategory[activeSidebar] || [];

  const sidebarItems = [
    { icon: chart, label: "Sales Block" },
    { icon: monitor, label: "Office Block" },
    { icon: folder, label: "Insight Block" },
    { icon: message, label: "Service Block" }
  ];

  // FeatureItem component for the features list
  const FeatureItem = ({ text }) => (
    <div className="flex items-start gap-3 mb-3 mt-2">
      <img 
        src={circlecheck} 
        alt="Checkmark" 
        className="w-5 h-5 flex-shrink-0"
      />
      <span className="text-[13px] text-[#787C87] font-['Geist'] font-normal tracking-[0.01em]">
        {text}
      </span>
    </div>
  );

  return (
    <div className="relative bg-[#010003] text-white w-full min-h-screen py-8 px-4">
      {/* Header Section - Outside Dashboard */}
      <div id="solutions-dash" className="max-w-[80em] mx-auto mb-8">
        <div className="mb-8">
          <h2 className="font-['CalSans'] font-medium text-2xl text-white tracking-[0.02em] text-left mb-4">
            Wir beraten nicht nur. <span className="block mt-1"></span>Wir setzen um.
          </h2>
          <p className="font-['Geist'] font-normal text-sm text-[#ADB0B9] pb-6">
            Wir zeigen dir nicht nur, wo KI den größten Hebel für dein Business hat. Wir setzen die Lösungen auch direkt für dich um. Inhouse, maßgeschneidert und nahtlos integriert in deine bestehenden Systeme. So bekommst du nicht nur eine Roadmap, sondern echte Resultate.
          </p>
        </div>
      </div>

      {/* Mobile Dashboard Container */}
      <div className="w-full max-w-[80em] mx-auto">
        {/* Sidebar Navigation - 2x2 Grid for Mobile */}
        <div className="grid grid-cols-2 gap-2 pb-4 mb-6">
          {sidebarItems.map((item, index) => (
            <div
              key={index}
              onClick={() => setActiveSidebar(item.label)}
              className={`flex items-center gap-2 px-4 py-3 rounded-lg cursor-pointer ${
                activeSidebar === item.label
                  ? 'bg-[#1a1c23] text-white' 
                  : 'text-[#666] bg-[#0D0E12] hover:text-white'
              }`}
            >
              <img 
                src={item.icon} 
                alt={item.label} 
                className="w-4 h-4"
              />
              <span className="text-sm font-medium text-[#ADB0B9]">{item.label}</span>
            </div>
          ))}
        </div>

        {/* Main content area with cards - Swipeable Carousel for Mobile */}
        <div className="relative">
          <div 
            ref={carouselRef}
            className="flex overflow-x-auto no-scrollbar pb-6 -mx-4 px-4"
          >
            <div className="flex gap-4" style={{ minWidth: 'fit-content' }}>
              {dashboardItems.map((item, index) => (
                <div 
                  key={item.id}
                  className="dashboard-item bg-[#070709] border border-[rgba(120,124,135,0.25)] rounded-xl p-4 relative overflow-hidden flex-shrink-0 w-[280px]"
                >
                  {/* Background Image */}
                  <div className="absolute inset-0 w-full h-full z-0 opacity-5">
                    <img 
                      src={ProductCardBg} 
                      alt="" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  {/* Content Container */}
                  <div className="relative z-10 flex flex-col h-full">
                    {/* Icon and Title */}
                    <div className="flex items-center gap-3 mb-3">
                      <img 
                        src={iconMap[item.icon]}
                        alt={item.title} 
                        className="w-10 h-10 flex-shrink-0"
                      />
                      <h4 className="text-white text-[18px] font-['Geist'] font-medium tracking-[0.01em]">
                        {item.title}
                      </h4>
                    </div>
                    
                    {/* Description */}
                    <p className="text-[13px] text-[#787C87] font-['Geist'] font-normal tracking-[0.01em] leading-relaxed mb-4">
                      {item.description}
                    </p>
                    
                    <div className="mt-2 flex-grow flex flex-col">
                      {/* FullLine SVG */}
                      <div className="mb-3 w-full">
                        <img 
                          src={fullline} 
                          alt="" 
                          className="w-full h-auto"
                        />
                      </div>
                      
                      {/* Features List */}
                      <div className="flex-grow">
                        {item.features && item.features.map((feature, index) => (
                          <FeatureItem key={index} text={feature} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions_Dash_Mobile;